import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { A as AlertWrapper, a as AlertIconWrapper, b as AlertContent, c as AlertHeading, S as StyledCloseButton } from './Alert.styles-AI0uwlWg.js';
import { I as Icon } from '../Icon/Icon-U2206Nrv.js';
import { T as Text } from '../Text/Text-D-u18aLP.js';
import { i as infoCircle, r as rocketSolid, c as check, e as exclamationTriangle, a as exclamation } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-B_pWoZ1u-Bxh9jPb6.js';

const chooseIcon = $variant => {
  switch ($variant) {
    case 'error':
      return exclamation;
    case 'warning':
      return exclamationTriangle;
    case 'success':
      return check;
    case 'spotlight':
      return rocketSolid;
    default:
      return infoCircle;
  }
};
const Alert = ({
  children,
  closeButtonLabel = 'Dismiss message',
  header,
  headerLevel = 'h4',
  hideIcon = false,
  isOpen = true,
  onClose,
  variant = 'info',
  withCloseButton = false,
  ...rest
}) => {
  if (!isOpen) return null;
  return /*#__PURE__*/React__default.createElement(AlertWrapper, _extends({}, rest, {
    $variant: variant
  }), !hideIcon && /*#__PURE__*/React__default.createElement(AlertIconWrapper, {
    $variant: variant,
    withHeader: !!header
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: chooseIcon(variant),
    size: header ? 'xlarge' : 'large'
  })), /*#__PURE__*/React__default.createElement(AlertContent, {
    direction: "column",
    justifyContent: "center",
    alignItems: "flex-start"
  }, header && /*#__PURE__*/React__default.createElement(AlertHeading, {
    renderAs: headerLevel,
    size: "medium"
  }, header), children && /*#__PURE__*/React__default.createElement(Text, null, children)), withCloseButton && /*#__PURE__*/React__default.createElement(StyledCloseButton, {
    label: closeButtonLabel,
    onClick: onClose,
    size: "small",
    withHeader: !!header
  }));
};

export { Alert as A };
//# sourceMappingURL=Alert-CsAg5g9l.js.map
